import { render, staticRenderFns } from "./CampaignLevels.vue?vue&type=template&id=19bf55ac"
import script from "./CampaignLevels.vue?vue&type=script&lang=js"
export * from "./CampaignLevels.vue?vue&type=script&lang=js"
import style0 from "./CampaignLevels.vue?vue&type=style&index=0&id=19bf55ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports